import { render, staticRenderFns } from "./Dash-posts-feed-card.vue?vue&type=template&id=01a3cb38&scoped=true"
import script from "./Dash-posts-feed-card.vue?vue&type=script&lang=js"
export * from "./Dash-posts-feed-card.vue?vue&type=script&lang=js"
import style0 from "./Dash-posts-feed-card.vue?vue&type=style&index=0&id=01a3cb38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a3cb38",
  null
  
)

export default component.exports